export default __webpack_public_path__ + "static/media/flow4.a8485abd.svg";